import Axios from '../utils/axios-utils';

// create Expense
export const createExpense = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/expenses`, {
            vehicleId: data.vehicleId,
            jobId: data.jobId,
            spentBy: data.spentBy,
            vendorId: data.vendorId,
            category: data.category,
            // linkedId: data.linkedId,
            accountingCode: data.accountingCode,
            expenseTime: data.expenseTime,
            currency: data.currency,
            amount: data.amount,
            shared: data.shared,
            paymentMethod: data.paymentMethod,
            note: data.note,
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Expense error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Expense failed" }
        };
    }
};

// update expense
export const updateExpense = async (accountId, expensesId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/expenses/${expensesId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update expenses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update expenses failed" }
        };
    }
};

// delete Expense
export const deleteExpense = async (accountId, expensesId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/expenses/${expensesId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete Expense error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete Expense failed" },
            status: error.response?.status || 500
        };
    }
};

// get all Expenses
export const getAllExpenses = async (accountId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/expenses`, {
            params: { from, to },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All expenses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All expenses failed" }
        };
    }
};


// update Expense status
export const updateExpenseStatus = async (accountId, expensesId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/expenses/${expensesId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update expense Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update expense Status failed" }
        };
    }
};

// get  Expense media
export const getExpenseMedia = async (accountId, expensesId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/expenses/${expensesId}/media`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get Expense media error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get Expense media failed" }
        };
    }
};

// get all Expenses statuses
export const getAllExpensesStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/expenses/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Incident statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Incident statuses failed" }
        };
    }
};

// get all expenses categories
export const getAllExpenseCategories = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/expenses/categories`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Expenses Categories error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Expenses Categories failed" }
        };
    }
};

// get all expenses payment methods
export const getAllExpensePaymentMethods = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/expenses/methods`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Expenses Payemnts Methods error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Expenses Payemnts Methods failed" }
        };
    }
};
